<template>
  <div class="InfoTooltip">
    <div class="prompt">{{ prompt }}</div>
    <div class="tooltip">
      <svg width="16" height="10" class="tooltipTri">
        <polygon points="0,10 8,0 16,10" fill="#08192E" />
      </svg>
      <div class="heading">{{ heading }}</div>
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prompt: String,
    heading: String,
    text: String,
  },
}
</script>

<style scoped>

.InfoTooltip {
  display: inline-block;
  position: relative;
}

.InfoTooltip:hover .tooltip {
  visibility: visible;
}

.tooltip {
  visibility: hidden;
  padding: var(--spacing-3);
  border-radius: 4px;
  background-color: var(--bg-color-dark-blue);
  color: var(--text-color-white);
  position: absolute;
  left: -11px;
  top: 31px;
  width: 15rem;
  z-index: 10;
}

.tooltipTri {
  position: absolute;
  top: -10px;
  left: 10px;
}

.heading {
  font-weight: 600;
  font-size: var(--font-size-1);
}

.text {
  font-weight: 400;
  font-size: var(--font-size-1);
  white-space: break-spaces;
}

.prompt {
  font-weight: 400;
  font-size: var(--font-size-0);
  color: #8D8D8D;
}
</style>
